/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Modal } from "react-bootstrap";
import ScrollBar from "react-perfect-scrollbar";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ImageBox from "../ImageBox/ImageBox";

export default function TestModalReadOnly(props) {
  const normalize = (name) =>
    name
      .trim()
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const handleImageClick = (index) => {
    const viewerUrl = `/photo-viewer?photos=${encodeURIComponent(
      JSON.stringify(props.test.images)
    )}&photo=${index}`;
    window.open(viewerUrl, "_blank");
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="no-border">
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="dialogheader">
            <div className="d-flex">
              <h5 style={{ fontWeight: "bolder" }}>Test</h5>
            </div>

            <img
              className="iconstyle crossicon"
              src={require("../../../assets/icons/x_light50@3x.png")}
              alt="icon"
              onClick={props.onHide}
            />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "0px" }}>
        <div className="dialogbody">
          <div className="mt-3">
            <span className="text-light20 fw-bolder">Test Type</span>
            <div className="mt-2">
              <span className="gray-bold-text font-italic">
                {props.test.test.name}
              </span>
            </div>
          </div>

          <div className="mt-3">
            <span className="text-light20 fw-bolder">Sample Type</span>
            <div className="mt-2">
              <span className="gray-bold-text font-italic">
                {props.test.test_sample.name}
              </span>
            </div>
          </div>

          <div className="mt-3">
            <span className="text-light20 fw-bolder">
              Sample Info: {props.test.code}
            </span>
            <div key={`sample-info-`} className="mt-2">
              <span className="gray-bold-text font-italic">
                {props.test.sample_info
                  .sort((a, b) => {
                    const aName = normalize(a.name);
                    const bName = normalize(b.name);

                    if (aName === "Lab Code" && bName === "Sample Location")
                      return -1;
                    if (aName === "Sample Location" && bName === "Lab Code")
                      return 1;

                    return 0;
                  })
                  .filter((j) => j.pivot.value)
                  .map((i) => i.pivot.value)
                  .join(", ")}
                {props.test.sample_info.filter((j) => j.pivot.value).length ===
                  0 && "No sample info added."}
              </span>
            </div>
          </div>

          <div className="mt-3">
            <span className="text-light20 fw-bolder">Test Photos</span>
            <div className="mt-2">
              <ScrollBar className="d-flex flex-row pb-1">
                <TransitionGroup className="d-flex">
                  {props.test.images.map((item, i) => (
                    <CSSTransition
                      timeout={500}
                      key={`test_image_${i}`}
                      classNames="item"
                    >
                      <div
                        onClick={() => handleImageClick(i)}
                        style={{ cursor: "pointer" }}
                      >
                        <ImageBox src={item.url} />
                      </div>
                    </CSSTransition>
                  ))}
                  {!props.test.images.length ? (
                    <span className="gray-bold-text font-italic">
                      No photos available
                    </span>
                  ) : null}
                </TransitionGroup>
              </ScrollBar>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="no-border">
        <div className="w-100 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={props.onEdit}
          >
            Edit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
